import React, { useContext, useEffect } from "react";
import ClientCover from "./ClientCover";
import ClientList from "./ClientList";
import { MenuContext } from "../../App";

function Clients() {
  const [isMenuClicked, setIsMenuClicked] = useContext(MenuContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setIsMenuClicked(!isMenuClicked);
  }, []);

  return (
    <div className="w-full py-2 flex flex-col gap-y-10">
      <ClientCover />
      <ClientList />
      <div className="w-full flex justify-center items-center">
        <div className="w-3/5 gap-y-5 pb-10 flex flex-col justify-center items-center text-center">
          <p className="text-2xl md:text-6xl">
            Get in touch with us and discover how we can push you or your
            company forward.
          </p>
          <button className="text-xl md:text-2xl p-2 md:p-5 bg-cyan-600 bg-opacity-50 rounded-lg hover:bg-transparent hover:border-2 hover:border-cyan-600">
            Get In Touch
          </button>
        </div>
      </div>
    </div>
  );
}

export default Clients;
